/**
 * Helper functions para formatação de dados
 * no módulo de Solicitações de Transporte
 */

/**
 * Formata uma data no formato brasileiro (dd/mm/yyyy)
 * @param {string|Date} dateTime - Data a ser formatada
 * @returns {string} Data formatada ou string vazia
 */
export const formatDate = dateTime => {
  if (!dateTime) return ''

  try {
    const date = new Date(dateTime)

    return date.toLocaleDateString('pt-BR')
  } catch (error) {
    return ''
  }
}

/**
 * Formata uma hora no formato brasileiro (HH:mm)
 * @param {string|Date} dateTime - Data/hora a ser formatada
 * @returns {string} Hora formatada ou string vazia
 */
export const formatTime = dateTime => {
  if (!dateTime) return ''

  try {
    const date = new Date(dateTime)

    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  } catch (error) {
    return ''
  }
}

/**
 * Formata uma hora para o formato do time picker (HH:MM)
 * @param {string|Date} dateTime - Data/hora a ser formatada
 * @returns {string|null} Hora formatada ou null
 */
export const formatTimeForPicker = dateTime => {
  if (!dateTime) return null

  try {
    const date = new Date(dateTime)

    return date.toTimeString().substring(0, 5) // HH:MM format
  } catch (error) {
    return null
  }
}

/**
 * Formata um endereço completo
 * @param {object} locationData - Objeto com dados do endereço
 * @returns {string} Endereço formatado
 */
export const formatAddress = locationData => {
  if (!locationData) return '-'

  const {
    street, number, neighborhood, city, uf, zip_code: zipCode,
  } = locationData

  const addressParts = [
    street || '',
    number || '',
    neighborhood || '',
    city || '',
  ].filter(part => part.trim() !== '')

  const ufPart = uf || ''
  const zipPart = zipCode ? `, ${zipCode}` : ''

  if (addressParts.length === 0 && !ufPart) return '-'

  return `${addressParts.join(', ')}${ufPart ? ` - ${ufPart}` : ''}${zipPart}`
}

/** * Retorna as iniciais do nome de uma pessoa
 * @param {object} person - Objeto com dados da pessoa (deve conter a propriedade 'name')
 * @returns {string} Iniciais em maiúsculo ou string vazia
 */
export const getInitials = person => {
  if (!person || !person.name) return ''
  const names = person.name.split(' ')
  const firstInitial = names[0] ? names[0][0] : ''
  const lastInitial = names[names.length - 1] ? names[names.length - 1][0] : ''

  return `${firstInitial}${lastInitial}`.toUpperCase()
}

/** * Retorna o primeiro e último nome de um motorista
 * @param {object} driver - Objeto com dados do motorista (deve conter a propriedade 'name')
 * @returns {string} Primeiro e último nome ou 'A definir'
 */
export const getDriverFirstAndLastName = driver => {
  if (!driver || !driver.name) return 'A definir'

  const nameParts = driver.name.trim().split(' ')
  if (nameParts.length === 1) {
    return nameParts[0]
  }
  const firstName = nameParts[0]
  const lastName = nameParts[nameParts.length - 1]

  return `${firstName} ${lastName}`
}

export const getStatusExpectedOnBackend = status => {
  const statusMap = {
    'não iniciada': 'new_solicitations',
    'em trânsito': 'in_trip',
    cancelada: 'cancelled',
    'em checklist': 'in_checklist',
    finalizada: 'done',
  }

  return statusMap[status.toLowerCase()] || 'Não iniciada'
}
